export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Muted-Red-81df7ee110a3dd44384b9bfcc85f41ad.svg";